import React, { useContext, useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi"; 
import className from "classnames";
import { AppContext } from "../../services/Appcontext";

export default function Search({primary, secondary, placeholder,defaultChecked}) {
    const classes = className('',{
       "flex items-center bg-amber rounded-[8px] w-full h-[40px] px-4 text-black " :primary,
       "flex items-center bg-white border-amber rounded-[8px] w-full h-[40px] px-4 text-amber" :secondary,
    })

    const inputclasses = className('',{
        "w-full bg-transparent outline-none ms-2 text-black placeholder-black text-start" :primary,
        "w-full bg-transparent outline-none ms-2 text-amber placeholder-amber text-start" :secondary,
     })
    
    const {handleSearch, setSearchValue, searchValue,
            searchQuery, setsearchQuery
      
    } = useContext(AppContext)
    
    ////this if im gonna search after finishing the word
    const [localSearchValue, setLocalSearchValue] = useState("");
    // const triggerSearch=()=>{
    //   setSearchValue(localSearchValue)
    //   setLocalSearchValue("")
    // }

    // // this if im gonna add the logic of the searcg here...
    //  const [searchValue, setSearchValue] = useState("");
    //  const handleSearch =()=>{
    //   console.log("handleIconSearch")
    //   console.log(searchValue);
    //   setSearchValue("");
    //  }
    // console.log("im in this pafe in the search",defaultChecked)

    useEffect(() => {
      // Reset search values when the component mounts
      setSearchValue("");
      setsearchQuery("");
  }, [setSearchValue, setsearchQuery]);

    const onChangeHandle = (e) => {

        if(defaultChecked === "fields"){
            // console.log("im in fields page")
            setsearchQuery(e)
        }
        else if(defaultChecked === "chars"){
          // console.log("im in characters page")
          setSearchValue(e)
        }
    }
     const handleKeyDown = (e) => {
      if (e.key === "Backspace") {
        e.preventDefault(); // Prevent the default backspace behavior
        const value = e.target.value.slice(0, -1);
        onChangeHandle(value);
    }
     };
  
  return (
    <div className={classes}>
      <FiSearch 
      // onClick={handleSearch}
      // onClick={triggerSearch}
      size={24}
      className=""
      />

      <input
        type="text"
        placeholder={placeholder}
        className={inputclasses}
        value={defaultChecked === "fields" ? searchQuery : searchValue}
        // value={localSearchValue}
        onChange={e => onChangeHandle(e.target.value)}
        // onChange={e => setLocalSearchValue(e.target.value)}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
}
